<template>
    <div v-if="cpdPrice" style="font-size: 1em;display: inline-block;">
        <div  v-if="item.prices && item.prices.length > 0" style="font-size: 1.2em; margin:2px 7px;display: inline-flex;flex-direction: row;border: 1px solid gray;padding: 4px;">
            <div style="padding:0px 4px;" class="agx-theme-bg">{{ currency }}</div>
            <div style="padding:0px 4px;">{{ cpdPrice.min.price }}</div>
            <div style="padding:0px 8px;" v-if="cpdPrice.max!==null"> ~ {{ cpdPrice.max.price }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: { type: Object, default: null }
    },
    data: function () {
        return {

        };
    },
    computed: {
        currency: function () {
            return this.$store.getters.configs.currency;
        },
        cpdPrice() {
            var item = this.item;
            if (item && item.prices && item.prices.length > 0) {
                //console.log('price', item.prices);
                var prices = item.prices;
                if (prices.length === 1){
                    return { min: prices[0], max: null };
                }
                if(prices.length >= 2){
                    prices.sort((a, b) => { 
                        //console.log('a vs b', a.price, b.price);
                        return a.price - b.price 
                    });
                }

                return { min: prices[0], max: prices[prices.length - 1] };
            }
            return null;
        }
    },
    methods: {

    },
    created: function () {

    },
    destroyed: function () {

    },
    mounted: function () {

    }
}
</script>